export default __webpack_public_path__ + "static/media/Petfinder.575f4d00.svg";